import { useCallback } from 'react';
import { Icon } from '@polichat/flamboyant';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import { QuickMessageSelectorOptions } from '../../types/types';
import { QuickTypes } from '../../types/constants';

import styles from './QuickItem.module.css';
export interface QuickIconProps {
  messageType: QuickMessageSelectorOptions;
}
export function QuickIcon({ messageType }: Readonly<QuickIconProps>) {
  // Traduções
  const quickMessageText = useGlotaT('spa.messageBuilder.quickMessages');
  const templateText = useGlotaT('spa.messageBuilder.template');
  const optionsListText = useGlotaT('spa.messageBuilder.optionsList');
  const interactiveButtonsText = useGlotaT('spa.messageBuilder.interactiveButtons');
  
  const getQuickTypeIcon = useCallback(() => {
    switch (messageType) {
      case QuickTypes.QUICK:
        return (
          <span title={quickMessageText}>
            <Icon icon="poli-icon pi-rocket-fill" color={'var(--primary)'} />
          </span>
        );
      case QuickTypes.TEMPLATE:
        return (
          <span title={templateText}>
            <Icon
              icon="poli-icon pi-whatsapp-api-fill"
              color="var(--whatsapp-color)"
            />
          </span>
        );

      case QuickTypes.LIST_OPTION:
        return (
          <span title={optionsListText}>
            <Icon
              icon="poli-icon pi-barmenu-fill"
              color="var(--secondary-75)"
            />
          </span>
        );

      case QuickTypes.BUTTONS:
        return (
          <span title={interactiveButtonsText}>
            <Icon
              icon="poli-icon pi-menu-mobile-fill"
              color="var(--secondary-75)"
            />
          </span>
        );

      default:
        return <></>;
    }
  }, [quickMessageText, templateText, optionsListText, interactiveButtonsText]);
  return <span className={styles.text_name__type}>{getQuickTypeIcon()}</span>;
}
